module.exports = "<div class=\"day-weekday\">\n    <span ng-bind=\"::day.dayOfWeek.substr(0, 1)\"></span><span ng-bind=\"::day.dayOfWeek.substr(1, 1)\"></span><span ng-bind=\"::day.dayOfWeek.substr(2, 1)\"></span>\n</div>\n<div class=\"day-date\">\n    <span ng-bind=\"::day.$formatted.dayDate\"></span>\n</div>\n<div class=\"flex-row flex-noshrink\">\n    <span class=\"day-hours\" ng-bind=\"Timesheets.getDayHours(day)\" xbind-refresh-when=\"['$refresh:day', '$refresh:hours', '$refresh:timesheet']\"></span>\n    <span class=\"day-hours-label\">Hrs</span>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/directives/day-header/day-header-mobile.html
// module id = 447
// module chunks = 22